/**
 * customActivityRefsPerEntity defines what extra Activity References should be created
 * to have information about some related entity as a dedicated record in addition to stored JSON state.
 * It allows to implement searching for related entities. For instance `Project` entity contains `addressId` field which
 * references to Address entity and this information stored as JSON object in `activity_reference.state` column.
 * It allows to find activity references by project ID but it is not possible to find activity references that
 * include changes for specific address ID.
 * To enable this, customActivityRefsPerEntity specifies what extra references should be created in addition to main
 * activity reference. In this way activity_reference will contain a record with `reference_identity` that points to
 * extra entity (in our example to Address) which allows to perform efficient lookup by address ID.
 **/
export const CUSTOM_ACTIVITY_REFS_PER_ENTITY = new Map([
    [
        'Project',
        [
            (entityAttr) => {
                if (!entityAttr.addressId) {
                    return null;
                }
                return {
                    entityName: 'Address',
                    id: entityAttr.addressId,
                };
            },
        ],
    ],
    [
        'LabelAssignment',
        [
            (entityAttr) => {
                if (!entityAttr.entity || !entityAttr.entityId) {
                    return null;
                }
                return {
                    entityName: entityAttr.entity,
                    id: entityAttr.entityId,
                };
            },
        ],
    ],
    [
        'ClientEmail',
        [
            (entityAttr) => {
                if (!entityAttr.clientId) {
                    return null;
                }
                return {
                    entityName: 'Client',
                    id: entityAttr.clientId,
                };
            },
        ],
    ],
    [
        'ClientPhoneNumber',
        [
            (entityAttr) => {
                if (!entityAttr.clientId) {
                    return null;
                }
                return {
                    entityName: 'Client',
                    id: entityAttr.clientId,
                };
            },
        ],
    ],
]);
